import * as React from "react";
import { AuthorizationInfo } from "../patient-portal/AuthorizationInfo";
import { getI18NKey } from "../commons/model/patient/PatientRelationship";
import LabelledDataForm from "../label/LabelledDataForm";

export default function AuthorizationInformationItemsList({
  authorizationInfo,
}: {
  authorizationInfo: AuthorizationInfo;
}) {
  const fragments = authorizationInfo.authorizations.map((authorization) => (
    <React.Fragment key={authorization.uid}>
      <h3>{i18n[getI18NKey(authorization.relationship)]}</h3>
      <LabelledDataForm
        data={[
          {
            label: i18n["Page.Portal.AuthorizationInformation.AuthorisedPerson.Title"],

            value: authorization.firstName + " " + authorization.lastName,
          },
        ]}
      />
    </React.Fragment>
  ));

  return <div className={"authorization-details"}>{fragments}</div>;
}
